  import { Component, OnInit } from '@angular/core';
  import { Comments } from '../../classes/blogs.interface';
  import { DoctorService } from '../../services/doctor.service';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../authentication/auth.service';
import { Router } from '@angular/router';

  @Component({
    selector: 'app-forumhome',
    templateUrl: './forumhome.component.html',
    styleUrls: ['./forumhome.component.css']
  })
  export class ForumhomeComponent implements OnInit {
    askvetModal: any;
    forum: any;
    comment: Comments[];
    commentsarray = [];
    breed: any;
    lifestage: any;
    public loading = false;
    cat = 'Recent';
    loadall = 0;
    lifestagefilter: any;
    breedfilter: any;
    pettypefilter: any;
    categoryfilter: any;
    userrole = 0;
    p = 1;
    constructor(private doctorService: DoctorService, public commonService: CommonService,
    private authService: AuthService, private router: Router) {
      this.checkUserType();
     }

    ngOnInit() {
      this.loading = true;
      this.getForum();
      this.commonService.getLifestages()
      .subscribe(
        (x) => {
          this.lifestage = x;
        }
       );
       this.doctorService.getallBreeds()
       .subscribe(
         (x) => {
           this.breed = x;
         }
        );
    }
    checkUserType() {
      this.userrole = this.authService.getRoleId();
   }
    getForum() {
      this.doctorService.getForum()
      .subscribe(
        (x) => {
          this.loading = false;
          this.forum = x;
          for (let i = 0; i < this.forum.length; i++) {
              this.getCommentsOnBlog(this.forum[i].id);         }
        });
    }

    getCommentsOnBlog(bid) {
      let totalcomment;
      this.doctorService.getCommentsOnBlog(bid)
      .subscribe(
        (comment: Comments[]) => {
          this.comment = comment;
          if (this.comment && this.comment.length > 0) {
            totalcomment = this.comment.length;
            this.commentsarray['id' + bid] = totalcomment;
          } else {
            totalcomment = 0;
            this.commentsarray['id' + bid] = totalcomment;
          }
        }
      );
    }
    categoryCount(ct) {
      let total = 0;
      for (let i = 0; i < this.forum.length ; i++) {
        if (this.forum[i].category === ct) {
          total = total + 1;
        }
      }
      return total;
    }
    pettypeCount(pt) {
      let total = 0;
      for (let i = 0; i < this.forum.length ; i++) {
        if (this.forum[i].pet_type == pt) {
          total = total + 1;
        }
      }
      return total;
    }
    breedCount(bt) {
      let total = 0;
      for (let i = 0; i < this.forum.length ; i++) {
        if (this.forum[i].breed_id == bt) {
          total = total + 1;
        }
      }
      return total;
    }
    lifestageCount(lt) {
      let total = 0;
      for (let i = 0; i < this.forum.length ; i++) {
        if (this.forum[i].lifestage_id == lt) {
          total = total + 1;
        }
      }
      return total;
    }
    loadAll() {
      this.loadall = 1;
      this.cat = 'all';
    }
    filterbyCategory(id) {
      this.loadall = 1;
      this.pettypefilter = undefined;
      this.lifestagefilter = undefined;
      this.breedfilter = undefined;
      this.categoryfilter = id;
      this.cat = id;
    }
    filterbyLifestage(id, name) {
      this.loadall = 1;
      this.pettypefilter = undefined;
      this.breedfilter = undefined;
      this.categoryfilter = undefined;
      this.lifestagefilter = id;
      this.cat = name;
    }
    filterbyBreed(id, name) {
      this.loadall = 1;
      this.pettypefilter = undefined;
      this.categoryfilter = undefined;
      this.lifestagefilter = undefined;
      this.breedfilter = id;
      this.cat = name;
    }
    filterbyPet_type(id, name) {
      this.loadall = 1;
      this.categoryfilter = undefined;
      this.lifestagefilter = undefined;
      this.breedfilter = undefined;
      this.pettypefilter = id
      this.cat = name;
    }
    reset() {
      this.categoryfilter = undefined;
      this.lifestagefilter = undefined;
      this.breedfilter = undefined;
      this.pettypefilter = undefined;
      this.cat = 'All';
    }
    asktoVet() {
      const flag = 6;
      this.commonService.setActivatepath(flag);
      this.router.navigate(['/forum/asktovet']);
    }
  }
